import { useQuery } from '@tanstack/react-query';

import { apiCall, apiClient } from 'shared/client/apiClient';
import { useWorkMode } from 'shared/utils/useWorkMode';

export const getLearningActivityDraftById = async (learningActivityDraftId: string, includeDeleted?: boolean) => {
  return apiCall(
    apiClient.GET('/learning-activity-drafts/{learningActivityDraftId}', {
      params: { path: { learningActivityDraftId }, query: { ...(includeDeleted && { includeDeleted: 'true' }) } }
    })
  );
};

export const learningActivityDraftByIdQueryKey = ({ learningActivityDraftId }: { learningActivityDraftId?: string }) =>
  ['learning-activity-draft', { learningActivityDraftId }] as const;

export const useGetLearningActivityDraftByIdQuery = (learningActivityDraftId?: string) => {
  const { isPlayerAssignment } = useWorkMode();

  return useQuery({
    queryKey: learningActivityDraftByIdQueryKey({ learningActivityDraftId }),
    queryFn: () => getLearningActivityDraftById(learningActivityDraftId as string, isPlayerAssignment),
    enabled: !!learningActivityDraftId
  });
};
